import React from 'react'
import { observer } from 'mobx-react'
import Spinner from 'components/Spinner'
import CallCenterJobViewModel from './CallCenterJobViewModel'
import CallCenterJobCreationForm from './CallCenterJobCreationForm'
import styles from './JobSection.sass'
import sharedStyles from '../CallCenter.sass'
import JobCreationViewModel from 'jobs/creation/JobCreationViewModel'
import JobNavigation from '../../components/JobNavigation'
import link from '../../../infra/link'
import { pluralize } from '../../../utils/pluralization-util'
import { ContactCard } from '../ClientDetails'

interface Props {
  vm: CallCenterJobViewModel
}

export default observer(function JobSection({ vm }: Props) {
  const jobCreation = vm.jobCreation

  return (
    <div className={styles.jobSection}>
      <div className={styles.main}>{renderMainPanel(vm, jobCreation)}</div>
    </div>
  )
})

function renderMainPanel(
  vm: CallCenterJobViewModel,
  jobCreation: JobCreationViewModel | null,
) {
  const isInitializing = vm.initializeJob.pending || vm.loadExistingJob.pending

  if (isInitializing) {
    return (
      <div className={sharedStyles.spinnerContainer}>
        <Spinner size={20} />
      </div>
    )
  }

  if (!vm.hasActiveClient) {
    return <div className={styles.placeholder}>No active job.</div>
  }

  if (!jobCreation) {
    return null
  }

  return (
    <>
      <ContactCard
        fullName={vm.activeMember?.displayName ?? ''}
        email={vm.activeMember?.email ?? ''}
        phone={vm.activeMember?.phone ?? ''}
        workspace={vm.activeMember?.workspace.name ?? ''}
      />
      <div className={styles.guidance}>
        {vm.requiredQuestionsAmount > 0 ? (
          <>
            Answer the first{' '}
            {pluralize(
              'question',
              vm.requiredQuestionsAmount,
              `${vm.requiredQuestionsAmount} questions`,
            )}
            . Remaining questions are optional.
          </>
        ) : (
          <>All questions are optional. Provide as much detail as you can.</>
        )}
      </div>
      <CallCenterJobCreationForm
        jobCreation={jobCreation}
        requiredQuestionsAmount={vm.requiredQuestionsAmount}
      />
      <JobNavigation
        onPrevious={() => vm.goToCustomerLookup()}
        canProceed={vm.isReady}
        next={link.callCenterJobCheckout(jobCreation.job.id)}
      />
    </>
  )
}
